import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'src/common';
import styles from './index.module.scss';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEnvelopeOpen } from '@fortawesome/pro-light-svg-icons';
import RejectInboxMailButton from 'src/shared/CallOffs/RejectInboxMailButton';
import { useMarkInboxEmailsAsRead, useMarkInboxEmailsAsUnread } from 'src/models/callOffs/hooks';
import useSelectedCallOffs from 'src/reactiveVars/SelectedCallOffsVar';
import WSLabel from 'src/shared/BidPicker/WSLabel';
import BidPicker from 'src/shared/BidPicker';
import { useCloseSidebar } from 'src/shared/InfoSidebar/hooks';

export const CallOffsActionsMultiple: FC = () => {
  const { t } = useTranslation();

  const [selectedRows, setSelectedRows] = useSelectedCallOffs();
  const onCloseSidebar = useCloseSidebar();

  const clearSelectedCallOffs = useCallback(() => {
    setSelectedRows([]);
    onCloseSidebar();
  }, [onCloseSidebar, setSelectedRows]);

  const selectedMailIds = useMemo(() => selectedRows.map(r => r.id), [selectedRows]);

  const [markEmailsAsRead] = useMarkInboxEmailsAsRead();
  const [markEmailsAsUnread] = useMarkInboxEmailsAsUnread();

  const [isUnread, setIsUnread] = useState<boolean>();
  useEffect(() => {
    setIsUnread(selectedRows.some(r => !r.isRead));
  }, [selectedRows]);

  const markAsReadSelectedMails = useCallback(async () => {
    await markEmailsAsRead({ variables: { mailIds: selectedMailIds } });
    setIsUnread(false);
  }, [markEmailsAsRead, selectedMailIds]);

  const markAsUnreadSelectedMails = useCallback(async () => {
    await markEmailsAsUnread({ variables: { mailIds: selectedMailIds } });
    setIsUnread(true);
  }, [markEmailsAsUnread, selectedMailIds]);

  return (
    <ul
      className={classNames(styles.actionsMultipleTenders, {
        [styles.isAllActions]: true
      })}
    >
      <li className={classNames(styles.actionMultipleTenders, styles.addToWsAction)}>
        <BidPicker
          selectedCallOffs={selectedRows}
          mode={'short'}
          showTooltip
          onChange={clearSelectedCallOffs}
          eventSource={'CallOffsMultipleEmails'}
        />
        <WSLabel />
      </li>
      <li className={classNames(styles.actionMultipleTenders, styles.rejectAction)}>
        <RejectInboxMailButton selectedMailIds={selectedMailIds} onComplete={clearSelectedCallOffs} />
      </li>

      {isUnread ? (
        <li className={classNames(styles.actionMultipleTenders, styles.readAction)}>
          <Tooltip title={t('CallOffs.markAllEmailsAsRead')}>
            <FontAwesomeIcon
              icon={faEnvelopeOpen}
              onClick={markAsReadSelectedMails}
              className={classNames(styles.asReadButton)}
            />
          </Tooltip>
        </li>
      ) : (
        <li className={classNames(styles.actionMultipleTenders, styles.unreadAction)}>
          <Tooltip title={t('CallOffs.markAllEmailsAsUnread')}>
            <FontAwesomeIcon
              icon={faEnvelope}
              onClick={markAsUnreadSelectedMails}
              className={classNames(styles.asReadButton)}
            />
          </Tooltip>
        </li>
      )}
    </ul>
  );
};
export default CallOffsActionsMultiple;
